import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonBase, Chip, CircularProgress, Container, Divider, Fab, Grid, List, ListItem, ListItemText, Stack, SwipeableDrawer, TextField, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';

import supportimg from "../../assets/images/supportimg.png";
import Bottom from "../Bottom";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Top from "../Top";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import CreateIcon from '@mui/icons-material/Create';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import api from "../../utils/api";
import * as util from "../../utils/util";
// @ts-ignore
import InfiniteScroll from "react-infinite-scroller";
import { set } from "react-hook-form";

const questionListParam = {
  cusId: '',
  pageNum: 0
}

const SupportQuestion = () => {
  const navigate = useNavigate();
  const [expandedAccordions, setExpandedAccordions] = React.useState([10000000]);
  const [questionList, setQuestionList] = React.useState([]);
  const [questionListCount, setQuestionListCount] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const isRef = React.useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);

  function getQuestionList(page: any) {
    try {
      setTimeout(() => {
        questionListParam.cusId = localStorage.getItem('userCusID') || '';
        questionListParam.pageNum = page - 1;

        api.post(`customer/api/v1/CU_008_001`, questionListParam).then(res => {
          if (res.data.qnADTOList.length < 1) {
            setLoading(false);
            return false;
          }
          console.log(res);

          setQuestionList((prev) => prev.concat(res.data.qnADTOList));

        }).catch(function (error) {
          console.log(error)
        });
      }, page - 1 === 0 ? 0 : 1000);
    } catch (error) {

    }
  }

  return (
    <React.Fragment>
      <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 9, pb: 12, minWidth: 320 }}>
        <Top title='1:1 문의' />

        <Typography sx={{ m: '5px auto 10px auto', width: '100%', textAlign: 'center', fontSize: 16, fontWeight: 600, color: '#555', }}>내 문의 내역</Typography>

        <Box>
          <List sx={{ width: '100%', m: '10px auto' }}>
            <InfiniteScroll
              ref={isRef}
              loadMore={getQuestionList}
              hasMore={true}
              loader={
                <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
                  <CircularProgress />
                </Box>
              }
            >

              {questionList.length > 0 ? (
                questionList && questionList.map((item, index) => (
                  <ListItem key={index} alignItems="flex-start" sx={Card_Style} >
                    <ListItemText sx={{ pl: 2 }}
                      // primary={item['title']}
                      onClick={() => navigate('/Notice/SupportDetailQuestion', { state: { qnaId: item['qnaId'] } })}
                      secondary={
                        <React.Fragment>
                          <Stack direction={'column'} sx={{ width: '100%', p: 2, pl: 0, pr: 0, boxSizing: 'border-box' }}>

                            <Stack direction="row" >
                              <Typography component='div' sx={{ fontWeight: 700, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
                                {
                                  item['title']
                                }
                              </Typography>
                              {
                                item['status'] ? (
                                  <Chip label="답변완료" color="success" icon={<CheckIcon />} size="small" sx={{ ml: 'auto' }} />
                                ) : (
                                  <Chip label="답변대기" color="warning" icon={<MoreHorizIcon />} size="small" sx={{ ml: 'auto' }} />
                                )
                              }
                            </Stack>


                            <Typography component='div' sx={{ fontSize: 12, color: '#999' }}>
                              {
                                util.strNull(item['createDate']).substring(0, 10)
                              }
                            </Typography>

                          </Stack>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                ))
              ) : (
                <Box sx={{ textAlign: 'center', mt: 10 }}>
                  <SupportAgentIcon sx={{ fontSize: 50, color: '#999' }} />
                  <Typography sx={{ fontSize: 16, color: '#777' }}>
                    상담 내역이 없습니다.
                  </Typography>
                </Box>
              )}

            </InfiniteScroll>
          </List>

        </Box>

        <Box sx={{ position: 'fixed', bottom: 60, right: 10, '& > :not(style)': { m: 1, } }}>
          <Fab size="small" color="secondary" aria-label="Creat"
            onClick={() => {
              navigate('/Notice/SupportCreateQuestion');
            }}
          >
            <CreateIcon />
          </Fab>
        </Box>

        <Bottom />
      </Container>

    </React.Fragment>

  );
}

const Card_Style = {
  borderRadius: '20px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',
  marginBottom: '20px'
};

export default SupportQuestion;